import type { StorageAdapter } from "@repo/utils/lib";
import {
  announceConsentChange,
  COOKIE_CONSENT_KEY,
  type ConsentAnswer,
} from "../monitoring/consent";

export { COOKIE_CONSENT_KEY };

/** The cookie-notice answer; also gates browser monitoring. */
export type Consent = ConsentAnswer;

/** Read the stored banner choice; null when the user has not chosen yet. */
export function readConsent(storage: StorageAdapter): Consent | null {
  try {
    const value = storage.get(COOKIE_CONSENT_KEY);
    return value === "accepted" || value === "declined" ? value : null;
  } catch {
    // storage can throw (private mode, blocked site data)
    return null;
  }
}

export function writeConsent(storage: StorageAdapter, consent: Consent) {
  try {
    storage.set(COOKIE_CONSENT_KEY, consent);
  } catch {
    // choice still applies for this session via provider state
  }
  announceConsentChange();
}
